export const log = {
  "log.get": "log.get",
  "log.email.get": "log.email.get",
  "log.users.activity": "log.users.activity",
  "log.getcronlogs": "log.getcronlogs",
} as const;
